import { A } from "@solidjs/router";
import { AnvilMark } from "./Nav";

export default function Footer() {
  return (
    <footer class="border-t border-seam bg-iron-1 mt-auto">
      <div class="mx-auto max-w-6xl px-5 py-12">
        <div class="grid gap-8 md:grid-cols-4 pb-8 border-b border-seam/40">
          {/* Logo, pitch & operational status */}
          <div class="md:col-span-2">
            <div class="flex items-center gap-3">
              <AnvilMark class="h-14 w-14 shrink-0" />
              <div class="flex flex-col leading-snug">
                <span class="font-disp font-bold text-ink tracking-[0.14em] text-[13px] sm:text-[14px] uppercase">Throughput Lines</span>
                <span class="font-disp font-bold text-ink tracking-[0.14em] text-[13px] sm:text-[14px] uppercase">Of Code Per Day</span>
              </div>
            </div>
            <p class="mt-5 font-disp text-[10px] uppercase tracking-label text-ink-faint">
              Throughput Lines of Code Per Day
            </p>
            <p class="mt-3 text-[12px] leading-6 text-ink-dim max-w-sm">
              The MCP server for coding agents. Query symbol relationships instantly, eliminate context bloat, and have your agents spend 75% fewer tokens.
            </p>
          </div>

          {/* Links Column 1: Product */}
          <div>
            <div class="font-disp text-[10px] font-semibold uppercase tracking-label text-ink-faint mb-3">Product</div>
            <ul class="space-y-2">
              <li>
                <A href="/" class="text-[11px] text-ink-dim hover:text-ink no-underline">
                  Overview
                </A>
              </li>
              <li>
                <A href="/pricing" class="text-[11px] text-ink-dim hover:text-ink no-underline">
                  Pricing Plans
                </A>
              </li>
              <li>
                <A href="/blog" class="text-[11px] text-ink-dim hover:text-ink no-underline">
                  Blog
                </A>
              </li>
              <li>
                <A href="/releases" class="text-[11px] text-ink-dim hover:text-ink no-underline">
                  Releases
                </A>
              </li>
              <li>
                <A href="/models" class="text-[11px] text-ink-dim hover:text-ink no-underline">
                  Model Hub
                </A>
              </li>
            </ul>
          </div>

          {/* Links Column 2: Resources */}
          <div>
            <div class="font-disp text-[10px] font-semibold uppercase tracking-label text-ink-faint mb-3">Resources</div>
            <ul class="space-y-2">
              <li>
                <A
                  href="/benchmarks"
                  class="text-[11px] text-ink-dim hover:text-ink no-underline"
                >
                  MCP Benchmarks
                </A>
              </li>
              <li>
                <a
                  href="mailto:hello@s7.works"
                  class="text-[11px] text-ink-dim hover:text-ink no-underline"
                >
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer bottom details */}
        <div class="mt-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between text-[11px] text-ink-faint">
          <div>
            <span>© {new Date().getFullYear()} S7 Works · Built on Model Context Protocol (MCP).</span>
          </div>
          <div class="flex gap-4">
            <span class="text-ink-faint">75% input token reduction</span>
            <span class="text-ink-faint">·</span>
            <span class="text-ink-faint">4x fewer tokens · less for models to reason on</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
